import PropTypes from "prop-types";
import React from "react";

import { Text, textPropTypes } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

/** FlightCount displays the flight position in a reservation. */

export const FlightCount = (props) => {
  const { className, flightPosition, textProps, totalFlightsInReservation } = props;

  return (
    <Text {...getProps()}>
      {i18n("FlightCount__FLIGHT_COUNT", { flightPosition, totalFlightsInReservation })}
    </Text>
  );

  function getProps() {
    return {
      ...textProps,
      className,
    };
  }
};

FlightCount.propTypes = {
  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** Indicates the flight position in a reservation.  */
  flightPosition: PropTypes.number.isRequired,

  /** Props passed to the underlying Text component. See Text for more details. */
  textProps: PropTypes.shape(textPropTypes),

  /** Indicates the total number of flights in a reservation. */
  totalFlightsInReservation: PropTypes.number.isRequired,
};
